import * as React from "react";
import isEqual from "react-fast-compare";
import { GoogleReview } from "main/javascripts/types/googleReview";
import { H2 } from "main/javascripts/components/atoms/H2";
import { HorizontalRule } from "main/javascripts/components/atoms/HorizontalRule";
import { Paragraph } from "main/javascripts/components/atoms/Paragraph";
import { StarRating } from "main/javascripts/components/atoms/StarRating";
import { ReviewListStyle } from "main/javascripts/components/molecules/Spot/ReviewList/ReviewListStyle";
import { css } from "aphrodite";
import { StarNumRating } from "main/javascripts/components/molecules/StarRating/StarNumRating";
import { getGoogleReviewFormattedTime } from "main/javascripts/utils/googleReviewUtil";

export interface IProps {
  reviews: GoogleReview[];
  rating?: number;
}

// TODO: aphroditeと旧コンポーネント使用中
const ReviewListComponent: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { reviews, rating } = props;

  const renderTotalRating = (): JSX.Element | null => {
    if (!rating) {
      return null;
    }
    const ratingStyles: any = {
      block: ReviewListStyle.ratingBlock,
      starBlock: ReviewListStyle.starBlock,
      num: ReviewListStyle.starNum,
    };
    return <StarNumRating rating={rating} styles={ratingStyles} />;
  };

  const renderReviewList = (): JSX.Element[] => {
    const reviewLength: number = reviews.length;

    return reviews.map((review: GoogleReview, index: number) => {
      // const ratingPercentage: number = review.rating / 5 * 100;
      return (
        <div key={index}>
          <div className={css(ReviewListStyle.header)}>
            <StarRating rating={review.rating} />
            <div>
              <div className={css(ReviewListStyle.authorBlock)}>
                <span>{review.author_name}</span>{" "}
                <span>({getGoogleReviewFormattedTime(review)})</span>
              </div>
            </div>
          </div>
          <Paragraph styles={ReviewListStyle.review}>{review.text}</Paragraph>
          {index + 1 === reviewLength ? "" : <HorizontalRule />}
        </div>
      );
    });
  };

  if (reviews.length === 0) {
    return null;
  }
  return (
    <div>
      <H2 styles={ReviewListStyle.headline}>レビュー</H2>
      {renderTotalRating()}
      <div>{renderReviewList()}</div>
    </div>
  );
};

const areEqual: any = (prevProps: any, nextProps: any): any => {
  return isEqual(prevProps, nextProps);
};
export const ReviewList: any = React.memo(ReviewListComponent, areEqual);
